import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FaBullseye, FaRegHandshake, FaUsers, FaShieldAlt, FaClock, FaRegStar, FaHandHoldingHeart, FaPhone, FaEnvelope, FaMapMarkerAlt, FaArrowUp, FaWhatsapp } from 'react-icons/fa';
import { BsTelephoneFill, BsEnvelope } from 'react-icons/bs';
import { BiMap } from 'react-icons/bi';

import '../App.css';
import aboutImage1 from '../assets/images/about1.webp';
import aboutImage2 from '../assets/images/about2.jpg';
import aboutImage3 from '../assets/images/about3.jpeg';
import bannerImage from '../assets/images/banner.png';
import aboutImage from '../assets/images/about-img.jpg';



function Home() {
  const location = useLocation();

  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    let aboutOffset = null;
    const headerOffset = 100; // matches other scroll offsets

    const updateOffsets = () => {
      const aboutEl = document.getElementById('about');
      aboutOffset = aboutEl ? aboutEl.getBoundingClientRect().top + window.pageYOffset : null;
    };

    const checkScroll = () => {
      if (aboutOffset === null) updateOffsets();
      const reachedAbout = aboutOffset !== null && (window.pageYOffset + headerOffset >= aboutOffset);

      // show back-to-top when near bottom OR when user has reached About
      const nearBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 200;
      setShowTopBtn(nearBottom || reachedAbout);

      // show whatsapp button when user has reached the About section (or beyond)
      setShowWhatsApp(Boolean(reachedAbout));
    };

    updateOffsets();
    window.addEventListener('scroll', checkScroll, { passive: true });
    window.addEventListener('resize', updateOffsets);
    checkScroll();
    return () => {
      window.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', updateOffsets);
    };
  }, []);

  const [showWhatsApp, setShowWhatsApp] = useState(false);
  const [showDot, setShowDot] = useState(true);

  // Blink the red dot when WhatsApp button is visible
  useEffect(() => {
    if (!showWhatsApp) return undefined;
    const id = setInterval(() => setShowDot(s => !s), 700);
    return () => clearInterval(id);
  }, [showWhatsApp]);

  // Handle scroll to section when navigating from other pages
  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          const headerOffset = 100; // Account for sticky header
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location.state]);

  return (
    <div className="App">
      <Header />

      {/* Hero Section */}
      <section
        className="hero-section"
        style={{ backgroundImage: `url(${bannerImage})` }}
      >
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-8 col-12">
              <div className="hero-content">
                <h1 className="hero-heading">
                  <span className="hero-heading-line1">Kerala's Trusted Healthcare</span>
                  <span className="hero-heading-line2">Staffing Partner</span>
                </h1>
                <p className="hero-text">
                  Kerala's Trusted Healthcare Staffing Agency Specializing In Locum Doctor Placements. Ensuring Uninterrupted, Quality Patient Care Through Reliable Medical Professionals — Anytime, Anywhere.
                </p>
              <button className="btn hero-btn">
  <a href="#contact" style={{ color: 'inherit', textDecoration: 'none' }}>
    Contact
  </a>
</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" className="about-section">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side - Image Grid */}
            <div className="col-lg-6 col-md-6 mb-4 mb-lg-0">
              <div className='row m-0'>
                <div className='col-6 p-2'>
                  <img src={aboutImage} alt="About Image 1" className="about-img" />
                </div>
                <div className='col-6 p-0'>
                  <div className='row m-0'>
                    <div className='col-12 p-2'>
                      <img src={aboutImage2} alt="About Image 1" className="about-img2" />
                    </div>
                    <div className='col-12 p-2'>
                      <img src={aboutImage3} alt="About Image 2" className="about-img2" />
                    </div>
                  </div>
                </div>
              </div>

            </div>

            {/* Right Side - Text Content */}
            <div className="col-lg-6 col-md-6 p-4">
              <div className="about-content">
                <h2 className="about-heading">About Us</h2>
                <p className="about-text">
                  247 Procare Is A Kerala-Based Healthcare Staffing Agency Specializing In The Placement Of Locum Doctors For Clinics, Private Hospitals, And Diagnostic Centres. We Understand That Continuity Of Care Is Vital — And That Staffing Shortages Can Impact Patient Outcomes And Operational Flow.
                </p>
                <p className="about-text">
                  Our Mission Is To Ensure That Every Healthcare Facility, Regardless Of Size Or Location, Has Access To Competent, Compassionate, And Reliable Medical Professionals Whenever Needed.
                </p>
                <p className="about-text">
                  Through Our Extensive Network Of Qualified Doctors And Our 24×7 Support System, 247 Procare Bridges The Gap Between Healthcare Providers And Skilled Professionals, Ensuring Seamless, Uninterrupted Care Delivery Across Kerala.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Objective Section */}
      <section id="objective" className="objective-section">
        <div className="container">
          <div className="objective-header mb-5">
            <h2 className="objective-heading">Our Objective</h2>
            <p className="objective-intro">
              To Provide Reliable, Qualified, And Readily Available Locum Doctors To Clinics, Private Hospitals, And Diagnostic Centres Across Kerala, Ensuring Uninterrupted Patient Care And Operational Efficiency.
            </p>
          </div>

          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="objective-card">
                <div className="objective-icon-wrapper">
                  <FaBullseye size={28} />
                </div>
                <h3 className="objective-card-title">Bridge The Gap</h3>
                <p className="objective-card-text">
                  Connect Healthcare Institutions In Need Of Temporary Medical Staffing With Skilled Professionals Seeking Flexible Work Opportunities.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="objective-card">
                <div className="objective-icon-wrapper">
                  <FaUsers size={28} />
                </div>
                <h3 className="objective-card-title">Quality Delivery</h3>
                <p className="objective-card-text">
                  Deliver Quality Medical Staffing With Trust And Professionalism, Maintaining The Highest Standards Of Care.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="objective-card">
                <div className="objective-icon-wrapper">
                  <FaShieldAlt size={28} />
                </div>
                <h3 className="objective-card-title">24×7 Support</h3>
                <p className="objective-card-text">
                  Round-The-Clock Support System Ensuring Healthcare Facilities Always Have Access To Qualified Medical Professionals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section id="vision-mission" className="vision-mission-section">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side - Image with Vision Overlay */}
            <div className="col-lg-6 col-md-6 mb-4">
              <div className="vision-image-wrapper position-relative p-lg-5">
                <div className="vision-image-placeholder"></div>
                <div className="vision-overlay-box">
                  <h3 className="vision-overlay-heading">Vision</h3>
                  <p className="vision-overlay-text">
                    To Become Kerala's Most Trusted And Efficient Healthcare Staffing Partner By Ensuring Every Healthcare Facility Has Access To Competent, Compassionate, And Dependable Locum Doctors — Anytime, Anywhere.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Side - Mission Text Boxes */}
            <div className="col-lg-6 col-md-6">
              <div className="mission-content">
                <div className="mission-item">
                  <p className="mission-item-text">
                    Provide Qualified Locum Doctors To Healthcare Institutions To Maintain Seamless Medical Services Without Disruption.
                  </p>
                </div>

                <div className="mission-item">
                  <p className="mission-item-text">
                    Offer Flexible, Rewarding Work Opportunities For Doctors Seeking Balance, Growth, And Experience Across Diverse Clinical Settings.
                  </p>
                </div>

                <div className="mission-item">
                  <p className="mission-item-text">
                    Collaborate With Clinics, Hospitals, And Diagnostic Centres To Deliver Tailored Staffing Solutions Based On Trust, Transparency, And Professionalism.
                  </p>
                </div>

                <div className="mission-item">
                  <p className="mission-item-text">
                    Uphold The Highest Standards Of Medical Ethics, Credential Verification, And Patient Safety In Every Placement.
                  </p>
                </div>

                <div className="mission-item">
                  <p className="mission-item-text">
                    Leverage Technology And A 24×7 Support Model To Match Healthcare Facilities With Suitable Professionals Quickly And Efficiently.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section id="core-values" className="core-values-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 p-2">
              <div className="core-values-header">
                <h2 className="core-values-heading">Core Values</h2>
                <p className="core-values-intro">
                  Our Values Guide Every Decision We Make And Define How We Serve Healthcare Institutions And Medical Professionals Across Kerala.
                </p>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 p-2">
              <div className="core-value-card">
                <div className="core-value-icon-wrapper">
                  <FaShieldAlt size={28} />
                </div>
                <h3 className="core-value-title">Integrity</h3>
                <p className="core-value-text">
                  We Operate With Honesty, Transparency, And Fairness In Every Interaction With Doctors, Healthcare Institutions, And Patients.
                </p>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 p-2">
              <div className="core-value-card">
                <div className="core-value-icon-wrapper">
                  <FaClock size={28} />
                </div>
                <h3 className="core-value-title">Reliability</h3>
                <p className="core-value-text">
                  Our 24×7 Service Ensures That Healthcare Facilities Can Always Depend On Us For Timely And Competent Staffing Support.
                </p>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 p-2">
              <div className="core-value-card">
                <div className="core-value-icon-wrapper">
                  <FaRegStar size={28} />
                </div>
                <h3 className="core-value-title">Excellence</h3>
                <p className="core-value-text">
                  We Are Committed To Maintaining The Highest Professional Standards In Doctor Selection, Placement, And Service Delivery.
                </p>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 p-2">
              <div className="core-value-card">
                <div className="core-value-icon-wrapper">
                  <FaHandHoldingHeart size={28} />
                </div>
                <h3 className="core-value-title">Compassion</h3>
                <p className="core-value-text">
                  We Believe That Quality Healthcare Begins With Empathy For Patients, Doctors, And Healthcare Providers Alike.
                </p>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 p-2">
              <div className="core-value-card">
                <div className="core-value-icon-wrapper">
                  <FaUsers size={28} />
                </div>
                <h3 className="core-value-title">Professionalism</h3>
                <p className="core-value-text">
                  Every Engagement Reflects Our Dedication To Accountability, Respect, And Ethical Medical Practice.
                </p>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 p-2">
              <div className="core-value-card">
                <div className="core-value-icon-wrapper">
                  <FaRegHandshake size={28} />
                </div>
                <h3 className="core-value-title">Collaboration</h3>
                <p className="core-value-text">
                  We Foster Strong Partnerships With Hospitals, Clinics, And Diagnostic Centres To Create Win-Win Outcomes For All Stakeholders.
                </p>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 p-2">
              <div className="core-value-card">
                <div className="core-value-icon-wrapper">
                  <FaBullseye size={28} />
                </div>
                <h3 className="core-value-title">Innovation</h3>
                <p className="core-value-text">
                  We Continuously Improve Our Processes Through Technology And Feedback, Ensuring Faster, Smarter, And More Effective Staffing Solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ready To Partner Section */}
      <section id="contact" className="partner-section">
        <div className="container">
          <div className="partner-header mb-5">
            <h2 className="partner-heading">Ready To Partner With Us?</h2>
            <p className="partner-subtitle">
              Whether You're A Healthcare Facility Seeking Qualified Locum Doctors Or A Medical Professional Looking For Flexible Opportunities, We're Here To Help 24x7.
            </p>
          </div>

          <div className="row m-0">
            <div className="col-lg-3 col-md-6">
              <a href="tel:+919747888247" className="partner-card text-decoration-none" style={{ cursor: 'pointer' }}>
                <div className="partner-icon-wrapper">
                  <BsTelephoneFill size={28} />
                </div>
                <h3 className="partner-card-title">Call Us</h3>
                <p className="partner-card-subtitle">(+91) 9747888247</p>
              </a>
            </div>

            <div className="col-lg-3 col-md-6">
              <a href="mailto:info@247procare.com" className="partner-card text-decoration-none" style={{ cursor: 'pointer' }}>
                <div className="partner-icon-wrapper">
                  <BsEnvelope size={28} />
                </div>
                <h3 className="partner-card-title">Email Us</h3>
                <p className="partner-card-subtitle">info@247procare.com</p>
              </a>
            </div>

            <div className="col-lg-3 col-md-6">
              <a href="https://maps.app.goo.gl/wVMH7UdvyqixpSDv6?g_st=iw" target="_blank" rel="noopener noreferrer" className="partner-card text-decoration-none" style={{ cursor: 'pointer' }}>
                <div className="partner-icon-wrapper">
                  <BiMap size={28} />
                </div>
                <h3 className="partner-card-title">Visit Us</h3>
                <p className="partner-card-subtitle">Kerala, India</p>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      {showTopBtn && (
        <button
          type="button"
          aria-label="Back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{
            position: 'fixed',
            right: 20,
            bottom: 40,
            zIndex: 9999,
            backgroundColor: '#0d6efd',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: 48,
            height: 48,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            cursor: 'pointer'
          }}
        >
          <FaArrowUp />
        </button>
      )}
      {showWhatsApp && (
        <a
          href="https://wa.me/919747888247"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contact on WhatsApp"
          style={{
            position: 'fixed',
            right: 20,
            bottom: 110,
            zIndex: 9999,
            backgroundColor: '#25D366',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: 56,
            height: 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            textDecoration: 'none'
          }}
        >
          <FaWhatsapp size={22} />
          <div style={{
            position: 'absolute',
            top: 6,
            right: 6,
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: showDot ? 'red' : 'transparent',
            boxShadow: showDot ? '0 0 6px rgba(255,0,0,0.7)' : 'none'
          }} />
        </a>
      )}
    </div>
  );
}

export default Home;
